import emekDrugs from '../Resus/emek/data/resus-drugs-definitions.json';
import emekProtocols from '../Resus/emek/data/emergency-protocols.json';
import emekAirwaysData from '../Resus/emek/data/airways.json';
import assutaDrugs from '../Resus/assuta/data/resus-drugs-definitions.json';
import assutaProtocols from '../Resus/assuta/data/emergency-protocols.json';
import assutaAirwaysData from '../Resus/assuta/data/airways.json';
import ichilovDrugs from '../Resus/ichilov/data/resus-drugs-definitions.json';
import ichilovProtocols from '../Resus/ichilov/data/emergency-protocols.json';
import ichilovAirwaysData from '../Resus/ichilov/data/airways.json';

import { MedicationGuide } from './types';

export interface EmergencyProtocolsData {
    emergencyProtocols: Array<{
      section: string;
      protocols: Array<{
        name: string;
        id: string;
        algorithmFile?: string;
        protocolFile?: string;
        attachments?: Array<{
          name: string;
          file: string;
        }>;
      }>;
    }>;
}

export const hospitalData: Record<string, {
    drugsData: MedicationGuide;
    protocols: EmergencyProtocolsData;
    airways: typeof emekAirwaysData;
    protocols_base_folder: string
  }> = {
    'apps': {
      drugsData: emekDrugs as MedicationGuide,
      protocols: emekProtocols as EmergencyProtocolsData,
      airways: emekAirwaysData,
      protocols_base_folder: "/assets/emek/protocols/"
    },
    'emek': {
      drugsData: emekDrugs as MedicationGuide,
      protocols: emekProtocols as EmergencyProtocolsData,
      airways: emekAirwaysData,
      protocols_base_folder: "/assets/emek/protocols/"
    },
    'rambam': {
      drugsData: emekDrugs as MedicationGuide,
      protocols: emekProtocols as EmergencyProtocolsData,
      airways: emekAirwaysData,
      protocols_base_folder: "/assets/emek/protocols/"
    },
        'assuta': {
          drugsData: assutaDrugs as MedicationGuide,
          protocols: assutaProtocols as EmergencyProtocolsData,
          airways: assutaAirwaysData,
      protocols_base_folder: "/assets/assuta/protocols/"
    },
    'ichilov': {
      drugsData: ichilovDrugs as MedicationGuide,
      protocols: ichilovProtocols as EmergencyProtocolsData,
      airways: ichilovAirwaysData,
      protocols_base_folder: "/assets/ichilov/protocols/"
    }
  };
  
  // Utility function to get hospital data
  export const getHospitalData = (hospital?: string) => {
    if (!hospital || !(hospital in hospitalData)) {
      return hospitalData.emek;
    }
    return hospitalData[hospital];
  };